import type { IEntitiesStore } from 'entities/EntitiesExport'
import { AIAutomationKey } from 'widgets/Menu/ui/MenuAIAutomation/constants/menuItems'
import { getPath } from 'widgets/Menu/ui/MenuAIAutomation/lib/getPathAIAutomation'
import { usePathMenu } from 'widgets/Menu/hooks/usePathMenu'

export const usePathAIAutomation = (userId: number, entities: IEntitiesStore) => {
  return usePathMenu(`${userId}_menu_${AIAutomationKey}`, (path) => {
    return getPath(path, entities)
  })
}
